export default {
  'get-list': {
    method: 'post',
    url: '/admincp/vehicle/category/list'
  },
  getAll: {
    method: 'post',
    url: '/admincp/vehicle/category/get-all'
  },
  getAllList: {
    method: 'get',
    url: '/admincp/vehicle/category/list'
  },
  add: {
    method: 'post',
    url: '/admincp/vehicle/category'
  },
  delete: {
    url: '/admincp/vehicle/category',
    method: 'delete'
  },
  archive: {
    url: '/admincp/vehicle/category/archive',
    method: 'delete'
  },
  restore: {
    url: '/admincp/vehicle/category/restore',
    method: 'put'
  },
  getById: {
    url: '/admincp/vehicle/category/ID',
    method: 'get'
  },
  edit: {
    url: '/admincp/vehicle/category/ID',
    method: 'put'
  },
  find: {
    method: 'get',
    url: '/admincp/vehicle/category/find'
  },
  'find-by-vehicle-tonnage': {
    method: 'get',
    url: '/admincp/vehicle/category/find-by-vehicle-tonnage?key=KEY'
  },
  lastCategory: {
    method: 'get',
    url: '/admincp/vehicle/category/last-category'
  }
}
